import React, { useState, useEffect } from "react";

const TemplatePreview = ({ selectedTemplate, values, setValues }) => {
  const [variables, setVariables] = useState([]);

  useEffect(() => {
    if (selectedTemplate?.components?.length) {
      const body = selectedTemplate.components.find((c) => c.type === "BODY");
      if (body?.text) {
        const matches = body.text.match(/{{\d+}}/g) || [];
        setVariables(matches);
      }
    }
  }, [selectedTemplate]);

  if (!selectedTemplate) return null;

  const bodyText =
    selectedTemplate.components.find((c) => c.type === "BODY")?.text || "";

  const previewText = variables.reduce((text, v, i) => {
    return text.replace(v, values[i + 1] || v);
  }, bodyText);

  const handleChange = (index, value) => {
    setValues((prev) => ({ ...prev, [index]: value }));
  };

  return (
    <div className="p-4 border rounded-md mt-4 bg-gray-50">
      <h3 className="font-semibold mb-2">Template Preview</h3>

      {/* Always show the body text */}
      <p className="text-sm mb-4 text-gray-700">
        {previewText || "No content found in this template."}
      </p>

      {/* Only show variable inputs if placeholders exist */}
      {variables.length > 0 && (
        <div>
          <h4 className="font-medium mb-1 text-sm">Enter Variable Values:</h4>
          {variables.map((v, i) => (
            <div key={i} className="mb-2">
              <label className="text-xs text-gray-600">Value for {v}</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1 text-sm"
                value={values[i + 1] || ""}
                onChange={(e) => handleChange(i + 1, e.target.value)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplatePreview;
